import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EMPTY, fromEvent, Observable, Subject, timer } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  take,
  tap,
} from 'rxjs/operators';

import { Servidor } from '../_classes/servidor';
import { ServidorSrh2 } from '../_classes/servidor-srh2';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { Afastamento } from './../_classes/afastamento';
import { Localidade } from './../_classes/localidade';
import { Util } from './../_classes/util';
import { UtilLogAcessoSistema } from './../_classes/util-log-acesso-sistema';
import { SnackBarService } from './../_servicos/snack-bar.service';

@Component({
  selector: 'app-me-encontre',
  templateUrl: './me-encontre.component.html',
  styleUrls: ['./me-encontre.component.scss'],
})
export class MeEncontreComponent implements OnInit {
  private readonly recurso: string = 'me-encontre'; //mesmo que a rota
  @ViewChild('termoPesquisado1', { static: true }) inputBusca: ElementRef;
  isSearching: boolean;

  afetadoLGPD: boolean = false;

  respostaBusca: string;

  readonly MENSAGEM_LGPD: string = 'protegido pela LGPD';

  carregando = false;
  carregandoS = false;
  carregandoL = false;
  carregandoAfastamento = false;
  carregandoDetalhes = false;
  textoBuscando: string;

  //servidorSrh2$: Observable<ServidorSrh2>;
  //servidorSrh2: ServidorSrh2 = new ServidorSrh2();

  servidorBuscado$: Observable<Servidor>;
  servidorBuscado: Servidor = new Servidor();

  dataSourceS: MatTableDataSource<ServidorSrh2>;
  dataSourceS$: Observable<ServidorSrh2[]>;

  dataSourceAfastamento: MatTableDataSource<Afastamento>;
  dataSourceAfastamento$: Observable<Afastamento[]>;

  localidadeBuscada$: Observable<Localidade>;
  localidadeBuscada: Localidade = new Localidade();

  dataSourceL: MatTableDataSource<Localidade>;
  dataSourceL$: Observable<Localidade[]>;

  erros$ = new Subject<boolean>();

  lengthS = 100;
  pageSizeS = 5;
  pageSizeOptionsS: number[] = [5, 10, 25, 100];
  pageEventS: PageEvent;

  lengthA = 100;
  pageSizeA = 5;
  pageSizeOptionsA: number[] = [5, 10, 25, 100];
  pageEventA: PageEvent;

  lengthL = 100;
  pageSizeL = 5;
  pageSizeOptionsL: number[] = [5, 10, 25, 100];
  pageEventL: PageEvent;

  @ViewChild('pagS', { read: MatPaginator, static: true })
  paginatorS: MatPaginator;
  @ViewChild('matS', { read: MatSort, static: true }) sortS: MatSort;

  @ViewChild('pagL', { read: MatPaginator, static: true })
  paginatorL: MatPaginator;
  @ViewChild('matL', { read: MatSort, static: true }) sortL: MatSort;

  @ViewChild('pagA', { read: MatPaginator, static: true })
  paginatorA: MatPaginator;
  @ViewChild('matA', { read: MatSort, static: false }) sortA: MatSort;

  mostrandoDetalhesS = false;
  mostrandoDetalhesL = false;

  itensAjudaS = [
    {
      titulo: 'xxx',
      texto: 'xxxxxx',
    },
  ];

  itensAjudaL = [
    {
      titulo: 'xx',
      texto: 'xxxx',
    },
  ];

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private snack: SnackBarService,
    private env: EnvService
  ) {
    this.isSearching = false;
    this.textoBuscando = '';
    this.respostaBusca = '';

    this.carregando = false;
    this.carregandoS = false;
    this.carregandoL = false;
    this.carregandoAfastamento = false;
    this.carregandoDetalhes = false;

    this.dataSourceS = new MatTableDataSource([]);
    this.dataSourceL = new MatTableDataSource([]);
    this.dataSourceAfastamento = new MatTableDataSource([]);
  }

  copiar(str: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = str;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.snack.abrirSnackBar('Email copiado com sucesso para memória!');
  }

  limparBusca() {
    this.inputBusca.nativeElement.value = '';
  }

  aplicarFiltroAfastamento(str: string) {
    this.dataSourceAfastamento.filter = str.trim().toLowerCase();
    this.atualizarPaginador();
  }

  getFuncaoSrh2(s: ServidorSrh2): string {
    let funcao = '';

    if (s) {
      if (s.codCom) {
        funcao = s.codCom;
      }

      if (s.nomeCom) {
        if (funcao !== '') {
          funcao = funcao + ' - ' + s.nomeCom;
        } else {
          funcao = s.nomeCom;
        }
      }
    }
    return funcao;
  }

  getFuncao(s: Servidor): string {
    let funcao = '';

    if (s) {
      if (s.servidorTodos) {
        if (s.servidorTodos.dsFuncaoComissionada != null) {
          funcao = s.servidorTodos.dsFuncaoComissionada;
        }

        if (s.servidorTodos.dsFuncaoComissionada != null) {
          if (funcao !== '') {
            funcao = funcao + ' - ' + s.servidorTodos.dsFuncaoConfianca;
          } else {
            funcao = s.servidorTodos.dsFuncaoConfianca;
          }
        }
      }
    }
    return funcao;
  }

  buscarServidorPorLocalidade(str: string) {
    this.inputBusca.nativeElement.value = 'localidade:' + str;
    this.mostrandoDetalhesL = false;
    this.buscar(this.inputBusca.nativeElement.value);
  }

  ngOnInit() {
    if (this.env.servidor) {
      this.inicializar();
    } else {
      this.servService.getServidorComFuncao2().then(() => this.inicializar());
    }
  }

  inicializar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    fromEvent(this.inputBusca.nativeElement, 'keyup')
      .pipe(
        // get value
        map((event: any) => {
          return event.target.value;
        }),
        // if character length greater then 2
        filter((res) => res.length > 2),
        // Time in milliseconds between key events
        debounceTime(1000),
        // If previous query is diffent from current
        distinctUntilChanged()
        // subscription for response
      )
      .subscribe((text: string) => {
        this.isSearching = true;
        this.buscar(text);
      });
    this.afetadoLGPD = false;
  }

  executarAoCarregarDatasourceAfastamento(x: Afastamento[]) {
    this.dataSourceAfastamento = new MatTableDataSource<Afastamento>(x);
    this.carregandoAfastamento = false;
    if (
      this.servidorBuscado &&
      this.env.servidor &&
      this.env.servidor.idServidor !== this.servidorBuscado.idServidor
    ) {
      this.afetadoLGPD = true;
      //console.log('Afetado pela LGPD quaisColunasmostrar');
    }
    this.atualizarPaginador();
  }

  executarAoCarregarDatasourceS(x: ServidorSrh2[]) {
    if (this.respostaBusca) {
      this.respostaBusca = this.respostaBusca + 'e ';
    }
    if (x.length === 1) {
      this.respostaBusca = this.respostaBusca + '1 servidor ';
    } else {
      this.respostaBusca = this.respostaBusca + x.length + ' servidores ';
    }

    this.dataSourceS = new MatTableDataSource<ServidorSrh2>(x);
    this.carregandoS = false;
    this.atualizarPaginador();
    this.atualizarCarregando(false);
  }

  executarAoCarregarDatasourceL(x: Localidade[]) {
    if (this.respostaBusca) {
      this.respostaBusca = this.respostaBusca + 'e ';
    }
    if (x.length === 1) {
      this.respostaBusca = this.respostaBusca + '1 localidade ';
    } else {
      this.respostaBusca = this.respostaBusca + x.length + ' localidades ';
    }
    this.dataSourceL = new MatTableDataSource<Localidade>(x);
    this.carregandoL = false;
    this.atualizarPaginador();
    this.atualizarCarregando(false);
  }

  atualizarCarregando(forcar: boolean) {
    if (forcar) {
      this.carregando = false;
    } else {
      this.carregando = this.carregandoS || this.carregandoL;
    }

    if (!this.carregando) {
      this.textoBuscando = '';
      this.isSearching = false;
    }
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  vazioQuandoNulo(str: string): string {
    return str ? str : '';
  }

  possoMostrar(tipo: String, serv: ServidorSrh2): boolean {
    console.log(serv, this.env.servidor, this.env.ID_LOCALIDADE_COM_DIREITO);

    /* SIATE 2023091424000487
    SGPes/SETIC-1284/SPJe e EJ -> colocado em variável de ambiente

    1. CPF: mostrar 'se e somente se' a pessoa logada pertencer a uma das 3 lotações citadas no chamado;
    2. ramal/celular/telefone: mostrar se marcado nas permissões de Intranet, ou, se a pessoa logada pertencer a uma das 3 lotações citadas no chamado;
    3. e-mail externo: mostrar se marcado nas permissões de Intranet, ou, se a pessoa logada pertencer a uma das 3 lotações citadas no chamado;
    4. afastamentos: ocultar coluna "Detalhe".
    */
    //tipo: C/ET
    let retorno: boolean = false;
    //?.exibirDadosIntranet !== 'N';
    //
    if (this.env.servidor) {
      if (
        this.servidorBuscado &&
        this.env.servidor.idServidor == this.servidorBuscado.idServidor
      ) {
        return true;
      }
      //this.env.servidor.servidorTodos.localidadeEx.idLocalidade = 0;
      /*
      switch (tipo.toUpperCase()) {
        case 'C':
          retorno =
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade ==
              1214 ||
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade ==
              1215 ||
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade == 1270;
          break;
        case 'ET':
          retorno =
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade ==
              1214 ||
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade ==
              1215 ||
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade ==
              1270 ||
            (serv?.exibirDadosIntranet ? serv.exibirDadosIntranet === 1 : true);
          break;
      }*/
      const localizacoesPermitidas =
        this.env.ID_LOCALIDADE_COM_DIREITO.split(',').map(Number); // Transformar string de ambiente em array de números

      switch (tipo.toUpperCase()) {
        case 'C':
          retorno = localizacoesPermitidas.includes(
            this.env.servidor.servidorTodos.localidadeEx?.idLocalidade
          );
          break;

        case 'ET':
          retorno =
            localizacoesPermitidas.includes(
              this.env.servidor.servidorTodos.localidadeEx?.idLocalidade
            ) &&
            (serv?.exibirDadosIntranet ? serv.exibirDadosIntranet === 1 : true);
          break;
      }
    }
    if (!retorno) {
      this.afetadoLGPD = true;
      //console.log('Afetado pela LGPD', tipo, retorno);
    }
    return retorno;
  }

  buscar(termoPesquisado: string) {
    if (termoPesquisado !== '') {
      if (termoPesquisado.length > 1) {
        this.dataSourceS = new MatTableDataSource([]);
        this.dataSourceL = new MatTableDataSource([]);
        if (this.env.servidor.servidorSrh2) {
          const source = timer(10000);
          const subscribe = source.subscribe((v) => {
            this.atualizarCarregando(true);
          });

          this.textoBuscando = 'buscando...';
          this.respostaBusca = '';
          this.carregando = true;
          // //console.log('ME-ENCONTRE: busca S disparada "' + termoPesquisado + '"');
          if (termoPesquisado.indexOf(':') > 0) {
            // //console.log('o termo tem :');
            switch (
              termoPesquisado.substring(0, termoPesquisado.indexOf(':'))
            ) {
              case 'localidade': {
                this.carregandoS = true;
                this.dataSourceS$ = this.service
                  .listarServidorSrh2DaLocalidade(
                    termoPesquisado.substring(
                      termoPesquisado.indexOf(':') + 1,
                      termoPesquisado.length
                    )
                  )
                  .pipe(
                    tap((a) => this.executarAoCarregarDatasourceS(a)),
                    take(1),
                    catchError((e) => {
                      this.handleError(e);
                      return EMPTY;
                    })
                  );
                break;
              }
              default: {
                /*//console.log('buscar por: ' + termoPesquisado);
                //console.log('indice: ' + termoPesquisado.indexOf(':'));
                //console.log('length: ' + termoPesquisado.length);
                //console.log('campo: ' + termoPesquisado.substring(0, termoPesquisado.indexOf(':')));
                //console.log('local: ' + termoPesquisado.substring(termoPesquisado.indexOf(':') + 1, termoPesquisado.length));*/
                break;
              }
            }
          } else {
            this.carregandoS = true;
            this.dataSourceS$ = this.service
              .listarServidorSrh2(termoPesquisado)
              .pipe(
                tap((a) => this.executarAoCarregarDatasourceS(a)),
                take(1),
                catchError((e) => {
                  this.handleError(e);
                  return EMPTY;
                })
              );

            // //console.log('ME-ENCONTRE: busca L disparada "' + termoPesquisado + '"');
            this.carregandoL = true;
            this.dataSourceL$ = this.service
              .listarLocalidade(termoPesquisado)
              .pipe(
                tap((a) => this.executarAoCarregarDatasourceL(a)),
                take(1),
                catchError((e) => {
                  this.handleError(e);
                  return EMPTY;
                })
              );
          }
        }
      }
    }
  }

  atualizarPaginador() {
    if (this.dataSourceS) {
      this.dataSourceS.paginator = this.paginatorS;
      this.dataSourceS.sort = this.sortS;
      this.dataSourceS.sortingDataAccessor = this.sortingDataAccessor;
    }

    if (this.dataSourceL) {
      this.dataSourceL.paginator = this.paginatorL;
      this.dataSourceL.sort = this.sortL;
      this.dataSourceL.sortingDataAccessor = this.sortingDataAccessor;
    }

    if (this.dataSourceAfastamento) {
      this.dataSourceAfastamento.paginator = this.paginatorA;
      this.dataSourceAfastamento.sort = this.sortA;
      this.dataSourceAfastamento.sortingDataAccessor = this.sortingDataAccessor;
    }
  }

  array_unique(array) {
    return array.filter((el, index, arr) => {
      return index === arr.indexOf(el);
    });
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  alterarLoading() {
    this.carregando = !this.carregando;
  }

  handleError(e: any) {
    this.isSearching = false;
    this.carregando = false;
    this.erros$.next(true);
    //this.alertService.mostrarAlertaPerigo('Erro, tente novamente mais tarde', e);
  }

  mostrarDetalhesS(s: ServidorSrh2) {
    this.mostrandoDetalhesL = false;
    this.carregandoDetalhes = true;
    this.servidorBuscado$ = this.service
      .getServidorPelaMatricula(s.matServidor)
      .pipe(take(1));
    this.servidorBuscado$.subscribe(
      (a: Servidor) => {
        //console.log('.servidor', a);
        //console.log('.servidorSrh2', s);
        this.executarAoCarregarDetalhesServidor(a, s);
      },
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
    this.mostrandoDetalhesS = true;
  }

  executarAoCarregarDetalhesServidor(a: Servidor, s: ServidorSrh2) {
    this.servidorBuscado = new Servidor(a);
    this.servidorBuscado.servidorSrh2 = new ServidorSrh2(s);
    console.log(this.servidorBuscado);
    this.carregandoAfastamento = true;
    //console.log('servidor', a);
    //console.log('servidorSrh2', s);
    this.dataSourceAfastamento$ = this.service
      .listarAfastamento(a.idServidor)
      .pipe(take(1));

    this.dataSourceAfastamento$.subscribe(
      (x: Afastamento[]) => {
        this.executarAoCarregarDatasourceAfastamento(x);
      },
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
    this.carregandoDetalhes = false;
  }

  mostrarDetalhesL(l: Localidade) {
    this.mostrandoDetalhesS = false;
    this.localidadeBuscada = new Localidade(l);
    this.mostrandoDetalhesL = true;
  }

  fecharDetalhes(sl: string) {
    if (sl === 'S') {
      this.mostrandoDetalhesS = false;
    }
    if (sl === 'L') {
      this.mostrandoDetalhesL = false;
    }
  }

  periodo(a: Afastamento): string {
    return Util.periodo(a.dtInicio, a.dtFim);
  }

  quaisColunasMostrar(sl: string): string[] {
    //  const isMobile = this.currentDisplay === 'mobile';
    //    return this.columnDefinitions
    // .filter(cd => !isMobile || cd.showMobile)
    // .map(cd => cd.def);
    // }
    if (sl === 'A') {
      if (
        this.servidorBuscado &&
        this.env.servidor &&
        this.env.servidor.idServidor == this.servidorBuscado.idServidor
      ) {
        return [
          'dtInicio',
          'totalDiasAfastamento',
          'dsGrupoAfastamento',
          'dsTipoAfastamento',
        ];
      } else {
        return ['dtInicio', 'totalDiasAfastamento', 'dsGrupoAfastamento'];
      }
    }

    if (sl === 'S') {
      if (this.mostrandoDetalhesS || this.mostrandoDetalhesL) {
        return ['nom'];
      } else {
        return ['nom', 'numCpf', 'matServidor', 'nrFnTrbSrv'];
      }
    }
    if (sl === 'L') {
      if (this.mostrandoDetalhesS || this.mostrandoDetalhesL) {
        return ['dsLocalidade'];
      } else {
        return ['dsLocalidade', 'dsNomeCidade'];
      }
    }
  }
}
